import React, {useState, useContext} from 'react'
import { Link } from 'react-router-dom'
import {IsLoggedContext} from '../Store'
import logo from '../Clear Logo.png'
import { config } from '../server'
import '../styles/login.css'
import '../styles/header.css';
const address = config.url.API_URL

const Login = () => {
	const [username, setusername] = useState("")
	const [password, setPassword] = useState("")
	const [,setIsLogged] = useContext(IsLoggedContext)

	const handleLogin = (event) => {
	event.preventDefault()
			const requestOptions = {
				method: 'POST',
				headers: { 
				'content-type': 'application/json' },
				body: JSON.stringify({ username: username, pass: password })
			};

			fetch(address + '/api/login', requestOptions).then(res => res.json()).then(data => {
			if(data.status === 'success') {
				localStorage.setItem("loggedIn", username)
				const getSess = localStorage.getItem('loggedIn')
			//  console.log(getSess)
			setIsLogged(getSess)
			// console.log(isLogged)
			} else if(data.status === 'failed') {
				alert('Invalid username/password combination')
			}
			}).catch(() => (
			alert('Invalid username/password combination')
			))
	}

	return (
	
		<div className="loginContainer">
			<div className="loginOverlay">
				<div className="loginForm">
					<Link to="/" style={{paddingTop: 10}}>
						<img src={logo} alt="" className="loginLogo"></img>
					</Link>
					<h1>Clusterfy</h1>
					<p>Achieve your greatest potential.</p>
					<form onSubmit={handleLogin}>
						<input placeholder="Username" className="loginInput" name="username" id="username" type="text" onChange={e => setusername(e.target.value)} />
						<input type="password" className="loginInput" placeholder="Password" name="password" value={password} onChange={e => setPassword(e.target.value)} />
						<input type='submit' value="Login" className="tealBtn"/>
						<div className="noAccountText">Don't have an account? Click <Link to="/sign-up">here</Link> to <Link to="/sign-up">sign up</Link>.</div>
					</form>
				</div>
				<div className="privacyPolicyBanner">
					By using this site you agree to our <a href="/terms">terms and conditions</a> as well as our <a href="/privacypolicy">privacy policy</a>.
				</div>
			</div>
		</div>

	)
}

export default Login
